import { ServiceData } from '@/types';

import articles from './COOKING_ARTICLES_EN.json';
import recipes from './COOKING_RECIPES_EN.json';
import videos from './COOKING_VIDEOS_EN.json';

export const COOKING_DATA_EN: ServiceData = {
  articles,
  recipes,
  videos,
};
